export default __webpack_public_path__ + "img/sagoo/sagoo4_1500.webp";